module.exports = __webpack_public_path__ + "static/articleimg4-278598a6e6d9ca7bfa51ebcc744bd6ed.jpeg";